export const storageKey = {
  TOKEN: 'token',
};

export enum CookieKeys {
  token = 'token',
}

export const storage = {
  setToken: (token: string) => localStorage.setItem(storageKey.TOKEN, token),
  getToken: () => localStorage.getItem(storageKey.TOKEN),
  removeToken: () => localStorage.removeItem(storageKey.TOKEN),
};
